import { Navigate } from "react-router-dom";
import { useAuth } from "../../../provider/authProvider";
import { useNotify } from "../../../shared/components/SuperToast";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { logout as logoutApi } from "../services/authApi";

const Logout = () => {
  const { setAccessToken, setUser } = useAuth();
  const { notify } = useNotify();
  const { t } = useTranslation();

  useEffect(() => {
    const performLogout = async () => {
      try {
        // Call backend logout to clear refresh token cookie
        await logoutApi();
      } catch (err) {
        console.error("Logout error:", err);
      }

      // Clear authentication tokens and user locally
      setAccessToken(null);
      setUser(null);
      notify(t("nounPhrases.loggedOutSuccessfully"), "success");
    };

    performLogout();
  }, [setAccessToken, setUser, notify, t]);

  return <Navigate to="/login" replace />;
};

export default Logout;
